import React, { memo } from 'react'
import { Handle, Position, type NodeProps } from 'reactflow'
import { Tag, ListPlus, NotePencil, BellRinging } from '@phosphor-icons/react'
import { describeAction } from '@/lib/workflowActions'
import { nodeCardClass, nodeChipClass, nodeHandleClass, nodeIcon, nodeTextClass } from '../../nodeCatalog'

const TYPE = 'action'
// The chip shows the configured action's own glyph; the catalog icon is the default.
const DEFAULT_ICON = nodeIcon(TYPE)

const actionIcons: Record<string, any> = {
  tag_contact: Tag,
  move_to_list: ListPlus,
  update_field: NotePencil,
  send_notification: BellRinging,
}

const ActionNode: React.FC<NodeProps> = ({ data, selected }) => {
  const Icon = actionIcons[data.action_type] || DEFAULT_ICON
  const summary = describeAction(data)

  return (
    <div className={nodeCardClass(TYPE, selected)}>
      <Handle
        type="target"
        position={Position.Top}
        className={nodeHandleClass(TYPE)}
      />
      <div className="flex items-center gap-2">
        <div className={nodeChipClass(TYPE)}>
          <Icon className={`w-4 h-4 ${nodeTextClass(TYPE)}`} />
        </div>
        <div className="flex-1 min-w-0">
          <p className={`text-[10px] font-emphasis uppercase tracking-wider ${nodeTextClass(TYPE)}`}>Action</p>
          <p className="text-sm font-medium text-foreground truncate">{data.label || 'Perform Action'}</p>
          <p className="text-[11px] text-muted-foreground truncate">{summary}</p>
        </div>
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        className={nodeHandleClass(TYPE)}
      />
    </div>
  )
}

export default memo(ActionNode)
